import React, { useRef, useEffect, useState } from "react";
import swal from "sweetalert";
import DocumentContainer from "../../../UI Component/DocumentViewer/DocumentCotainer";
import DragAndDrop from "../../common/DragAndDrop";
import Grid from "@material-ui/core/Grid";
import "./FilesView.scss";
import Axios from "axios";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import {
  GET_PATIENT_DOCTOR_DOCUMENTS,
  DELETE_FILE,
} from "../../ERXViewApiHandler/apiConstants";
import { UPLOAD_DOCUMENT } from "../../../ViewDocuments/ViewDocumentsApiHandler/apiConstants";
import ShareManualRxModal from "../../../ManualRX/ShareManualRxMoadal";
import { getSignedUrl } from "../../../../Util/API Calls/SignedAPIUrl";
import DisplayUploadedDocuments from "../../common/DisplayUploadedDocuments";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const FilesView = (props) => {
  const {
    appointmentData,
    docList,
    handleOnDrag,
    handleFileChange,
    setDocList,
  } = props;

  const user_type = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const staff_id = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const user_id = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const inputRef = useRef(null);
  const [documentShow, setDocumentShow] = useState(false);
  const [fileUrl, setFileUrl] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [fullView, setFullView] = useState(false);
  const [showRxModal, setShowRxModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [doctorDocs, setDoctorDocs] = useState([]);
  const [fileCount, setFileCount] = useState();

  useEffect(() => {
    docList.length == fileCount && handleUpload(docList);
  }, [docList, fileCount]);

  useEffect(() => {
    getPatientDoctorDocuments();
  }, []);

  // Actions ===>

  const closeNotification = () => {
    setDocumentShow(false);
    setFileUrl("");
    setFileName("");
    setFileType("");
    setFullView(false);
  };

  const handleOpenFile = () => {
    inputRef.current.click();
  };

  // <===

  // Api Calls ===>

  const getPatientDoctorDocuments = () => {
    let reqPayload = { appointment_id: appointmentData?.appointment_id };

    let resData = c2cPostApiHandler(GET_PATIENT_DOCTOR_DOCUMENTS, reqPayload);
    resData.then(([res, err]) => {
      if (!err) {
        if (res?.data?.statusCode === 200 && res?.data?.data?.length !== 0) {
          let docDocs = [];
          res.data.data.forEach((doc, index) => {
            let lastDot = doc.document_title.lastIndexOf(".");
            let documentName =
              doc.document_title.substring(0, lastDot) ||
              "Medical Record" + index;
            let documentType = doc.document_title.substring(lastDot + 1) || "";

            if (doc.uploaded_by.toLowerCase() !== "patient") {
              docDocs.push({
                ...doc,
                fileName: documentName,
                fileType: documentType,
              });
            }
          });
          setDoctorDocs([...docDocs]);
        } else {
          setDoctorDocs([]);
        }
      } else {
        setDoctorDocs([]);
      }
    });
  };

  const handleUpload = async (list) => {
    setLoader(true);
    let finalArr = [];
    let finalData;
    for (let doc of list) {
      finalData = await fileCheckDocuments([doc]);
      const updatedData = { ...finalData[0], document_type: 6 };
      finalArr.push(updatedData);
    }
    let reqPayload = {
      appointment_id: appointmentData?.appointment_id,
      notification_sent: true,
      docs: finalArr,
    };
    let resData = c2cPostApiHandler(UPLOAD_DOCUMENT, reqPayload);
    resData.then(([res, err]) => {
      setLoader(false);
      if (!err) {
        if (res.data.statusCode === 200) {
          getPatientDoctorDocuments();
          setDocList([]);
          swal({
            title: "Document Uploaded Successfully",
            icon: "success",
            timer: 2000,
          });
        }
      }
    });
  };

  const fileCheckDocuments = async (files) => {
    let prec = [];
    for (const file of files) {
      try {
        const signedUrl = await getSignedUrl(
          {
            file_size: file.size,
            doc_title: file.name,
            user_type: user_type,
            use_case: "upload-prescription-rev1",
          },
          file.fileDate
        );

        if (signedUrl) {
          if (signedUrl.statusCode) {
            prec.push({ error: signedUrl.statusCode });
            return prec;
          }
          prec.push({
            appointment_id: appointmentData?.appointment_id,
            document_path: signedUrl.fields["key"],
            document_title: file.name,
            document_size: file.size,
            uploader_type: user_type === APPLICABLE_ROLE.STAFF ? "4" : "1",
            uploader_id:
              user_type === APPLICABLE_ROLE.STAFF ? staff_id : user_id,
            uploader_source: "web",
          });
        }
      } catch (error) {
        C2CConsole.error(error);
      }
    }
    if (prec.length == files.length) return prec;
  };

  const handleFileChangeInput = (e, docType, actionType) => {
    let files =
      actionType === "dragFile" ? e.dataTransfer.files : e.target.files;
    setFileCount(files?.length);
    if (actionType === "dragFile") {
      handleOnDrag(e, docType);
    } else {
      handleFileChange(e, docType);
    }
  };

  // <===

  // Display UI ===>

  const displayUploadManualPrescription = () => {
    return (
      <div>
        {displayDragAndDrop()}
        {doctorDocs.length !== 0 && displayFilesUploaded()}
      </div>
    );
  };

  const displayDragAndDrop = () => {
    return (
      <div>
        <DragAndDrop
          fileList={docList}
          handleOnDrag={(e) => handleFileChangeInput(e, "docs", "dragFile")}
          handleOpenFile={handleOpenFile}
          handleUpload={handleUpload}
          hideUploaded={true}
        />
      </div>
    );
  };
  const handleDelete = async (data) => {
    let payload = {
      document_id: data.document_id,
      document_path: data.document_path,
    };
    await c2cPostApiHandler(DELETE_FILE, payload).then(([res, err]) => {
      if (!err) {
        swal({
          title: "Document Deleted Successfully",
          icon: "success",
          timer: 1000,
        }).then(() => {
          getPatientDoctorDocuments();
        });
      }
    });
  };
  const handleDownload = async (url, fileName, fileType) => {
    const blob = await Axios.get(url, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
      responseType: "blob",
    });
    const a = document.createElement("a");
    const href = window.URL.createObjectURL(blob.data);
    a.href = href;
    a.download = fileName + "." + fileType.trim();
    a.click();
  };

  const displayFilesUploaded = () => {
    return (
      <div>
        <div
          className="uploaded-file-header"
          style={{
            marginTop:
              docList.length !== 0 && window.innerWidth > 767 ? "5px" : "",
            color: "#F969A4",
          }}
        >
          Files
        </div>
        <div className="uploaded-files-container">
          <Grid container>
            {doctorDocs.map((file) => (
              <Grid
                item
                // xs={12}
                // md={3}
                key={file?.document_id}
              >
                <DisplayUploadedDocuments
                  data={file}
                  fileName={file.fileName}
                  fileType={file.fileType}
                  fileSize={file.file_size + "MB"}
                  downloadUrl={file.presigned_url}
                  fileDateTime={file.created_at.split("+")[0]}
                  handleDelete={handleDelete}
                  handleDownload={handleDownload}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    );
  };

  // <===

  return (
    <div className="upload-files-view-cont">
      {loader && (
        <div className="loader-container">
          <div className="load-loader">
            <div className="spinner-border text-dark" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      {displayUploadManualPrescription()}
      {documentShow && (
        <DocumentContainer
          cancelHandler={closeNotification}
          fullViewHandler={() => {
            setFullView(!fullView);
          }}
          url={fileUrl}
          fileName={fileName}
          fileType={fileType}
          width={""}
        />
      )}
      <input
        ref={inputRef}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => handleFileChangeInput(e, "docs", "selectFile")}
        multiple={true}
        accept={"image/*, .doc, .docx, .pdf, .txt, .xls, .csv"}
      />
      <ShareManualRxModal
        show={showRxModal}
        handleClose={() => {
          setShowRxModal(false);
        }}
      />
    </div>
  );
};

export default FilesView;
